const canAssignToQuestion = state =>
  state.assignedToLoggedStaffQuestions?.length === 0

const assignedToLoggedStaffQuestions = state =>
  state.assignedToLoggedStaffQuestions

const assignedToLoggedStaffQuestionId = state => {
  if (state.assignedToLoggedStaffQuestions) {
    return state.assignedToLoggedStaffQuestions[0].id
  }
  return undefined
}

export default {
  canAssignToQuestion,
  assignedToLoggedStaffQuestions,
  assignedToLoggedStaffQuestionId
}
